import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app.settings';
import { IPuntosSalida, ITramo } from '../../interfaces/exit-points.interface';
import { IPoderCalorifico } from '../../interfaces/calorific-power.interface';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import {
  ICliente,
  IclienteActions,
} from '../../interfaces/customers.interface';
import { ISociedad } from '../../interfaces/societies.interface';
import { ICiudad } from '../../interfaces/cities.interface';
import { IMercadoRelevante } from '../../interfaces/relevant-markets.interface';
import { IdistributionSystems } from '../../interfaces/distribution-systems.interface';
import { CONSUMPTION_SERVICES } from '../../const/http.const';
import {
  ClientesFilterResponse,
  IGeneralFilter,
} from '../../interfaces/general-filter.interface';

import { PREDICTION_SERVICES } from '../../const/http.const';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private appSettins: AppSettings
  ) {}

  //http
  async getService(service: string) {
    try {
      const response = await firstValueFrom(
        this.http.get(service).pipe(catchError(this.handleError))
      );
      return response && Array.isArray(response) && response.length === 0
        ? {}
        : response;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 409) {
      console.error('Error 409');
    } else {
      console.error('An error occurred', error.error);
    }

    return throwError('Someting bad happened, please try again');
  }
  async postService(url: string, data: any) {
    return await firstValueFrom(this.http.post(url, data));
  }

  async putService(url: string, data: any) {
    return await firstValueFrom(this.http.put(url, data));
  }

  async patchService(url: string, data: any) {
    return await firstValueFrom(this.http.patch(url, data));
  }

  async deleteService(url: string) {
    return await firstValueFrom(this.http.delete(url));
  }

  //Exit Points
  async getExitPoints(): Promise<IPuntosSalida[]> {
    const url = this.appSettins.administration.exitPoints;
    return await firstValueFrom(this.http.get<IPuntosSalida[]>(url));
  }

  async postExitPoint(data: IPuntosSalida): Promise<IPuntosSalida> {
    const url = this.appSettins.administration.exitPoints;
    delete data.uuid;
    return await firstValueFrom(this.http.post<IPuntosSalida>(url, data));
  }

  async updateExitPoint(data: IPuntosSalida): Promise<IPuntosSalida> {
    const url = `${this.appSettins.administration.exitPoints}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<IPuntosSalida>(url, data));
  }

  async deleteExitPoint(data: string): Promise<any> {
    const url = `${this.appSettins.administration.exitPoints}/${data}`;
    return await firstValueFrom(this.http.delete(url));
  }

  //Calorific Power
  async getCalorificPower(): Promise<IPoderCalorifico[]> {
    const url = this.appSettins.administration.calorificPower;
    return await firstValueFrom(this.http.get<IPoderCalorifico[]>(url));
  }

  async postCalorificPower(data: IPoderCalorifico): Promise<IPoderCalorifico> {
    const url = this.appSettins.administration.calorificPower;
    delete data.uuid;
    return await firstValueFrom(this.http.post<IPoderCalorifico>(url, data));
  }

  async updateCalorificPower(data: IPoderCalorifico): Promise<IPoderCalorifico> {
    const url = `${this.appSettins.administration.calorificPower}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<IPoderCalorifico>(url, data));
  }

  async deleteCalorificPower(data: string): Promise<any> {
    const url = `${this.appSettins.administration.calorificPower}/${data}`;
    return await firstValueFrom(this.http.delete(url));
  }

  //Customers
  async getCustomers(): Promise<ICliente[]> {
    const url = this.appSettins.administration.customers;
    return await firstValueFrom(this.http.get<ICliente[]>(url));
  }

  async postCustomer(data: IclienteActions): Promise<IclienteActions> {
    const url = this.appSettins.administration.customers;
    delete data.uuid;
    return await firstValueFrom(this.http.post<IclienteActions>(url, data));
  }

  async updateCustomer(data: IclienteActions): Promise<IclienteActions> {
    const url = `${this.appSettins.administration.customers}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<IclienteActions>(url, data));
  }

  async deleteCustomer(data: string): Promise<any> {
    const url = `${this.appSettins.administration.customers}/${data}`;
    return await firstValueFrom(this.http.delete(url));
  }

  //Demands
  async getDemands(): Promise<ICliente[]> {
    const url = this.appSettins.administration.customers;
    return await firstValueFrom(this.http.get<ICliente[]>(url));
  }

  //Sections
  async getSections(): Promise<ITramo[]> {
    const url = this.appSettins.administration.sections;
    return await firstValueFrom(this.http.get<ITramo[]>(url));
  }

  async deleteSection(data: string): Promise<any> {
    const url = `${this.appSettins.administration.sections}/${data}`;
    return await firstValueFrom(this.http.delete(url));
  }

  // //Gas Sources
  // async getGasSources(): Promise<IFuenteGas[]> {
  //   const url = this.appSettins.administration.gasSources;
  //   return await firstValueFrom(this.http.get<IFuenteGas[]>(url));
  // }

  // async postGasSources(data: IFuenteGasSalida): Promise<IFuenteGasSalida> {
  //   const url = this.appSettins.administration.gasSources;
  //   delete data.uuid;
  //   return await firstValueFrom(this.http.post<IFuenteGasSalida>(url, data));
  // }

  // async updateGasSources(data: IFuenteGasSalida): Promise<IFuenteGasSalida> {
  //   const url = `${this.appSettins.administration.gasSources}/${data.uuid}`;
  //   delete data.uuid;
  //   return await firstValueFrom(this.http.put<IFuenteGasSalida>(url, data));
  // }

  // async deleteGasSources(data: string): Promise<any> {
  //   const url = `${this.appSettins.administration.gasSources}/${data}`;
  //   return await firstValueFrom(this.http.delete(url));
  // }

  //Societies
  async getSocieties(): Promise<ISociedad[]> {
    const url = this.appSettins.administration.societies;
    return await firstValueFrom(this.http.get<ISociedad[]>(url));
  }

  async postSocietie(data: ISociedad): Promise<ISociedad> {
    delete data.uuid;
    const url = this.appSettins.administration.societies;
    return await firstValueFrom(this.http.post<ISociedad>(url, data));
  }

  async updateSocietie(data: ISociedad): Promise<ISociedad> {
    const url = `${this.appSettins.administration.societies}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<ISociedad>(url, data));
  }

  async deleteSocietie(data: ISociedad): Promise<ISociedad> {
    const url = `${this.appSettins.administration.societies}/${data.uuid}`;
    return await firstValueFrom(this.http.delete<ISociedad>(url));
  }

  //Cities
  async getCities(): Promise<ICiudad[]> {
    const url = this.appSettins.administration.cities;
    return await firstValueFrom(this.http.get<ICiudad[]>(url));
  }

  async postCity(data: ICiudad): Promise<ICiudad> {
    const url = this.appSettins.administration.cities;
    delete data.uuid;
    return await firstValueFrom(this.http.post<ICiudad>(url, data));
  }

  async updateCity(data: ICiudad): Promise<ICiudad> {
    const url = `${this.appSettins.administration.cities}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<ICiudad>(url, data));
  }

  async deleteCity(data: ICiudad): Promise<ICiudad> {
    const url = `${this.appSettins.administration.cities}/${data.uuid}`;
    return await firstValueFrom(this.http.delete<ICiudad>(url));
  }

  //Relevant Markets
  async getRelevantMarkets(): Promise<IMercadoRelevante[]> {
    const url = this.appSettins.administration.relevantMarkets;
    return await firstValueFrom(this.http.get<IMercadoRelevante[]>(url));
  }

  async postRelevantMarket(
    data: IMercadoRelevante
  ): Promise<IMercadoRelevante> {
    delete data.uuid;
    const url = this.appSettins.administration.relevantMarkets;
    return await firstValueFrom(this.http.post<IMercadoRelevante>(url, data));
  }

  async updateRelevantMarket(
    data: IMercadoRelevante
  ): Promise<IMercadoRelevante> {
    const url = `${this.appSettins.administration.relevantMarkets}/${data.uuid}`;
    delete data.uuid;
    return await firstValueFrom(this.http.put<IMercadoRelevante>(url, data));
  }

  async deleteRelevantMarket(
    data: IMercadoRelevante
  ): Promise<IMercadoRelevante> {
    const url = `${this.appSettins.administration.relevantMarkets}/${data.uuid}`;
    return await firstValueFrom(this.http.delete<IMercadoRelevante>(url));
  }

  //DistributionSystems
  async getDistributionSystems(): Promise<IdistributionSystems[]> {
    const url = this.appSettins.administration.distributionSystems;
    return await firstValueFrom(this.http.get<IdistributionSystems[]>(url));
  }

  async postdistributionSystems(
    data: IdistributionSystems
  ): Promise<IdistributionSystems> {
    const url = this.appSettins.administration.distributionSystems;
    return await firstValueFrom(
      this.http.post<IdistributionSystems>(url, data)
    );
  }

  async updatedistributionSystems(
    data: IdistributionSystems
  ): Promise<IdistributionSystems> {
    const url = `${this.appSettins.administration.distributionSystems}`;
    return await firstValueFrom(this.http.put<IdistributionSystems>(url, data));
  }

  async deletedistributionSystems(
    data: IdistributionSystems
  ): Promise<IdistributionSystems> {
    const url = `${this.appSettins.administration.distributionSystems}`;
    return await firstValueFrom(this.http.delete<IdistributionSystems>(url));
  }

  //consumption
  async httpGet(
    service: (typeof CONSUMPTION_SERVICES)[keyof typeof CONSUMPTION_SERVICES],
    endPoint: string
  ): Promise<any> {
    const url = `${this.appSettins.consumptionURL}/${service}/${endPoint}`;
    try {
      return await firstValueFrom(this.http.get<any>(url));
    } catch (err) {
      console.error(err);
    }
  }

  async httpPost(
    service: (typeof CONSUMPTION_SERVICES)[keyof typeof CONSUMPTION_SERVICES],
    data: any
  ): Promise<any> {
    const url = `${this.appSettins.consumptionURL}/${service}/`;
    try {
      return await firstValueFrom(this.http.post(url, data));
    } catch (err) {
      return err;
    }
  }

  async httpPut(
    service: (typeof CONSUMPTION_SERVICES)[keyof typeof CONSUMPTION_SERVICES],
    data: any
  ): Promise<any> {
    const url = `${this.appSettins.consumptionURL}/${service}/`;
    try {
      return await firstValueFrom(this.http.put(url, data));
    } catch (err) {
      return err;
    }
  }

  //GeneralFilter

  async getGeneralFilter(): Promise<IGeneralFilter> {
    const url = `${this.appSettins.administration.generalInfo}`;
    return await firstValueFrom(this.http.get<IGeneralFilter>(url));
  }

  //ClientsFilter
  async getClientsFilter(params: string): Promise<ClientesFilterResponse> {
    const url = `${this.appSettins.administration.generalInfo}/clientes?${params}`;
    return await firstValueFrom(this.http.get<ClientesFilterResponse>(url));
  }

  //CityGatesFilter
  async getCityGates(params: string): Promise<any> {
    const url = `${this.appSettins.administration.generalInfo}/city-gates?${params}`;
    return await firstValueFrom(this.http.get<any>(url));
  }

  //GetListSeasonals
  async getAllSeasonalList(): Promise<any> {
    const url = `${this.appSettins.predictionURL}/${PREDICTION_SERVICES.CALENDAR_PREDICTION}/seasonal`;
    return await firstValueFrom(this.http.get<any>(url));
  }
}
